<template>
  <div id="spinner"v-bind:class="{ loading: isLoading }">
    <div class="loader">
      <div class="loader">
          <div class="loader">
             <div class="loader">
             </div>
          </div>
      </div>
    </div>
  </div><!-- spinner -->
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Spinner',
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  }
</script>

<style lang="scss">
@import "../assets/scss/app.scss";
#spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 150px;
  height: 150px;
  z-index: -1;
  opacity: 0;
  transition: opacity .3s ease;
  &.loading {
    z-index: 10000;
    opacity: 1;
    .loader {
      width: calc(100% - 0px);
      height: calc(100% - 0px);
      border: 8px solid $gray-300;
      border-top: 8px solid $primary;
      border-radius: 50%;
      animation: rotate 5s linear infinite;
    }
  }
}

@keyframes rotate {
  100% {transform: rotate(360deg);}
}
</style>
